var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.REVIEWS.length
      ? _c(
          "div",
          { staticClass: "review-stats" },
          [
            _c("div", { staticClass: "review-stats__title" }, [
              _vm._v("\n      Общая оценка\n    ")
            ]),
            _c("div", { staticClass: "review-stats__body" }, [
              _c("div", { staticClass: "review-stats__stat" }, [
                _c("div", { staticClass: "review-stats__stat-title" }, [
                  _vm._v("\n          Рекомендуют:\n        ")
                ]),
                _c("div", { staticClass: "review-stats__stat-value" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.REVIEWS_SUMMARY.recommended || 0) +
                      " %\n        "
                  )
                ])
              ]),
              _c("div", { staticClass: "review-stats__total-score" }, [
                _vm._v("\n        " + _vm._s(_vm.REVIEW_RATING) + "\n      ")
              ]),
              _c("div", { staticClass: "review-stats__stat" }, [
                _c("div", { staticClass: "review-stats__stat-title" }, [
                  _vm._v("\n          Отзывов:\n        ")
                ]),
                _c("div", { staticClass: "review-stats__stat-value" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.REVIEWS_COUNT) + "\n        "
                  )
                ])
              ])
            ]),
            _c("stars-rating", {
              staticClass: "review-stats__stars-rating",
              attrs: { size: _vm.starsSize, value: _vm.REVIEW_RATING }
            }),
            _c(
              "div",
              { staticClass: "review-stats__size" },
              [
                _c("div", { staticClass: "review-stats__size-title" }, [
                  _vm._v("\n        Соответствие размеру\n      ")
                ]),
                _c(
                  "div",
                  { staticClass: "review-stats__size-bars" },
                  [
                    _c("radial-bar", {
                      attrs: { value: _vm.sizeSmall, title: "Маломерит" }
                    }),
                    _c("radial-bar", {
                      attrs: { value: _vm.sizeNormal, title: "Соответствует" }
                    }),
                    _c("radial-bar", {
                      attrs: { value: _vm.sizeLarge, title: "Большемерит" }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "review-stats__sizes-rating" },
                  [
                    _c("horizontal-bar", {
                      staticClass: "review-stats__sizes-rating-item",
                      attrs: { value: _vm.fit, title: "Посадка" }
                    }),
                    _c("horizontal-bar", {
                      staticClass: "review-stats__sizes-rating-item",
                      attrs: { value: _vm.quality, title: "Качество" }
                    }),
                    _c("horizontal-bar", {
                      attrs: {
                        value: _vm.photoAccuracy,
                        title: "Соответствие фото"
                      }
                    })
                  ],
                  1
                ),
                _c("ui-button", {
                  attrs: {
                    large: _vm.buttonIsLarge,
                    wide: "",
                    text: "Оставить отзыв"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("show-form")
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "review-stats__no-reviews" },
          [
            _c("div", { staticClass: "review-stats__no-reviews-title" }, [
              _vm._v("\n      Поделитесь своим мнением о товаре\n    ")
            ]),
            _c("div", { staticClass: "review-stats__no-reviews-text" }, [
              _vm._v(
                "\n      Это поможет другим покупателям принять решение о покупке\n    "
              )
            ]),
            _c("ui-button", {
              attrs: {
                large: _vm.buttonIsLarge,
                wide: "",
                text: "Оставить отзыв"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("show-form")
                }
              }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }